// Centralized API and uploads base URLs (configurable via env at build time)
export const API_BASE = process.env.REACT_APP_API_BASE_URL || 'https://petrochoice.org/api';
export const UPLOADS_BASE = process.env.REACT_APP_UPLOADS_BASE_URL || 'https://petrochoice.org/backend-laravel/public/uploads/';


